import Marionette from "backbone.marionette";
import GroupBy from "../../../models/groupby";
import templates from "../../../utils/templates";

const DEFAULTS = {
  tagName: "li",
  className: "options-wrapper",
  template: templates.find("group_by", "options"),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize(options) {
    this.model = new GroupBy({
      formParamName: options.formParamName,
      data: this._transform(options.data),
    });
  }

  // Transforms incoming data into one that can be used by the model
  _transform(data) {
    return data.map((item) => {
      return {
        label: item.description,
        value: item.key,
        checked: item.selected === "checked" ? true : false,
      };
    });
  }
}

export { View as default };
